;(function (angular, moment, _) {
  'use strict'

  angular
    .module('kilo.common.directives')
    .directive('criteriaSidebar', criteriaSidebarDirective)

  criteriaSidebarController.$inject = []

  function criteriaSidebarController () {
    var self = this

    self.$onInit = () => {
      _.extend(self, {
      })
      init()
    }

    function init () {
      // ?
    }
  }

  criteriaSidebarDirective.$inject = []

  function criteriaSidebarDirective () {
    return {
      restrict: 'E',
      scope: true,
      templateUrl: '/app/common/directives/criteria-sidebar/criteria-sidebar.html',
      controller: criteriaSidebarController,
      controllerAs: 'ctrl',
      bindToController: {
        search: '=',
        visible: '=',
        reset: '&',
        refresh: '&'
      }
    }
  }
})(window.angular, window.moment, window._)
